<div>
    <div class="wizard-header row">
        <div class="col-12 page-title">
            {{'specialOffers.title' | translate}}
        </div>
    </div>

    <div class="wizard-container">
        <button
            class="btn link-btn btn-back-txt"
            (click)="redirectToPrevStep()">
            <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
            <span>
                {{("specialOffers.wizard.previousStep" | translate)}}
            </span>
        </button>

        <div class="wizard-main-content">
            <form #form="ngForm">
                <ng-container class="wizard-item">
                    <div class="row">
                        <div class="col-12 wizard-question">
                            {{ "specialOffers.wizard.campaignDescription.title" | translate }}
                        </div>

                        <div class="row justify-content-center mb-3">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input required">
                                    {{ "specialOffers.wizard.campaignDescription.campaignTitle" | translate }}
                                </label>
                                <div>        
                                    <input
                                        HJSuppress
                                        kendoTextBox
                                        placeholder="{{'specialOffers.wizard.campaignDescription.placeholder.typeTitle' | translate}}"
                                        class="text-input"
                                        [disabled]="(specialOffer.status === specialOfferStatus.UPCOMING) && !specialOffer.allowEdit"
                                        [(ngModel)]="specialOffer.title"
                                        required
                                        #title="ngModel"
                                        name="other-textarea"/>
                                </div>
                            </div>
                        </div>

                        <div class="document-category row justify-content-center mb-3">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input required">
                                    {{ "specialOffers.wizard.campaignDescription.image" | translate }}
                                </label>
                                <div class="import-file-container">
                                    <input
                                        HJSuppress
                                        type="file"
                                        class="input-file cursor-pointer"
                                        [accept]="acceptExtensions"
                                        (change)="uploadFileInStoreHandler($event, false)"
                                    />
                                    <div class="import-file-label d-flex flex-column align-items-center gap-2">
                                        <div class="upload-icon-box d-flex align-items-center justify-content-center">
                                            <i class="app-icon icon icon-upload icon-lg"></i>
                                        </div>
                                        <div class="upload-info text-center">
                                            <div
                                                HJSuppress
                                                class="upload-hint"
                                                [innerHTML]="'common.uploadPresentationDocument' | translate">
                                            </div>
                                            <div 
                                                HJSuppress 
                                                class="upload-note">
                                                {{ 'JPG '+ ('common.or' | translate) +' PNG' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                *ngIf="specialOffer.campaignImageDocument"
                                class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <div class="document-item d-flex align-items-center uploaded-file-container p-2">
                                    <div class="document-name w-50 d-flex align-items-center">
                                        <span
                                            HJSuppress
                                            class="fw-bold">
                                            {{specialOffer.campaignImageDocument.documentName}}
                                        </span>
                                    </div>
                                    <button
                                        class="btn delete-btn custom-delete-btn ms-auto"
                                        (click)="removeFileHandler(null)">
                                        <i class="app-icon icon icon-delete icon-xl"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="row justify-content-center mb-3">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input description required">
                                    {{ "specialOffers.wizard.campaignDescription.description" | translate }}
                                </label>
                                <kendo-editor
                                    HJSuppress
                                    class="flex-grow-1 kendo-editor-resizable-vertical"
                                    name="message"
                                    required
                                    [iframe]="false"
                                    [resizable]="resizable"
                                    [(ngModel)]="specialOffer.description">
                                </kendo-editor>
                            </div>
                        </div>

                        <div class="document-category row justify-content-center mb-3">
                            <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                                <label class="label-input required">
                                    {{ "specialOffers.wizard.campaignDescription.attachments" | translate }}
                                </label>
                                <div class="import-file-container">
                                    <input
                                        HJSuppress
                                        type="file"
                                        class="input-file cursor-pointer"
                                        accept="application/pdf,application/doc,application/docx"
                                        (change)="uploadFileInStoreHandler($event, true)"/>
                                    <div class="import-file-label d-flex flex-column align-items-center gap-2">
                                        <div class="upload-icon-box d-flex align-items-center justify-content-center">
                                            <i class="app-icon icon icon-upload icon-lg"></i>
                                        </div>
                                        <div class="upload-info text-center">
                                            <div
                                                HJSuppress
                                                class="upload-hint"
                                                [innerHTML]="'common.uploadPresentationDocument' | translate">
                                            </div>
                                            <div class="upload-note">
                                                {{ 'PDF '+ ('common.or' | translate) +' WORD' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-container
                                *ngFor="let doc of specialOffer.campaignDocuments; let isLast = last, let index=index">
                                <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 ">
                                    <div class="document-item d-flex align-items-center uploaded-file-container p-2">
                                        <div class="document-name w-50 d-flex align-items-center">
                                            <span
                                                HJSuppress
                                                class="fw-bold">
                                                {{doc.documentName}}
                                            </span>
                                        </div>
                                        <button
                                            class="btn delete-btn custom-delete-btn ms-auto"
                                            (click)="removeFileHandler(index)">
                                            <i class="app-icon icon icon-delete icon-xl"></i>
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <div class="col-12 action">
                            <div class="d-flex justify-content-center mt-5">
                                <button
                                    class="btn primary-btn"
                                    [disabled]="(!specialOffer.title || !specialOffer.description || !specialOffer.campaignImageDocument || !specialOffer.campaignDocuments?.length)"
                                    (click)="nextStepHandler()">
                                    {{ "specialOffers.wizard.nextBtn" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </form>
        </div>
    </div>
</div>